import React, { useState } from 'react';
import { Typography, Button } from '@mui/material';
// ICONS
import AddIcon from '@mui/icons-material/Add';
// MODALS
import AddDetailModal from './modals/AddDetailModal';

export interface IQuestionDetailsManager {
  mode?: 'edit' | 'readOnly';
  details: string;
  updateDetails?: (html: string) => void;
}

const QuestionDetailsManager: React.FC<IQuestionDetailsManager> = ({
  mode = 'edit',
  details,
  updateDetails,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <div style={{ marginBottom: '15px' }}>
      <Typography fontWeight={600} sx={{ mb: '5px' }}>
        {mode === 'edit' ? 'Enter Question Details *' : 'Question Details'}
      </Typography>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <div
          className="view ql-editor ql-viewer"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: details }}
        />
      </div>
      {mode === 'edit' && (
        <div>
          <Button
            startIcon={<AddIcon />}
            onClick={() => setModalOpen(true)}
            sx={{ mt: '10px' }}
          >
            {details.trim() ? 'Edit' : 'Add'}
          </Button>
        </div>
      )}
      {isModalOpen && updateDetails && (
        <AddDetailModal
          open={isModalOpen}
          details={details}
          onClose={() => setModalOpen(false)}
          updateDetails={(html) => {
            updateDetails(html);
            setModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default QuestionDetailsManager;
